import React, { useEffect, useState } from 'react';

export default function ScrollDown() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const updateButtonVisibility = () => {
      const scrollEnd = window.innerHeight + window.scrollY >= document.body.scrollHeight;
      setVisible(!scrollEnd);
    };
    updateButtonVisibility();
    window.addEventListener('scroll', updateButtonVisibility);
    return () => {
      window.removeEventListener('scroll', updateButtonVisibility);
    };
  }, []);

  return (
    <>
      <div
        className={`scroll-button ${!visible && 'hidden'}`}
        onClick={() => {
          window.scroll({
            top: document.body.offsetHeight,
            left: 0,
            behavior: 'smooth',
          });
          setTimeout(() => {
            setVisible(false);
          }, 200);
        }}
      >
        &darr;
      </div>
      <style jsx>
        {`
          .scroll-button {
            position: fixed;
            bottom: 30px;
            right: 30px;
            width: 40px;
            height: 40px;
            font-size: 28px;
            background: #999;
            cursor: pointer;
            border-radius: 20px;
            color: white;
            text-align: center;
            line-height: 36px;
            opacity: 0.8;
            transition: opacity 0.3s ease-in;
          }
          .hidden {
            opacity: 0;
            transition: opacity 0.3s ease-out;
          }
        `}
      </style>
    </>
  );
}
